import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';

@Component({
  selector: 'app-vector-value',
  templateUrl: './vector-value.component.html',
  styleUrls: ['./vector-value.component.css']
})
export class VectorValueComponent implements OnInit {
  valueOne = null;
  valueTwo = null;
  valueThree = null;
  valueFour = null;
  valueFive = null;
  activeUser;

  constructor(public activeModal: NgbActiveModal, private adminService: AdminService) {
  }

  ngOnInit() {
    this.valueOne = this.getComponentValue(0);
    this.valueTwo = this.getComponentValue(1);
    this.valueThree = this.getComponentValue(2);
    this.valueFour = this.getComponentValue(3);
    this.valueFive = this.getComponentValue(4);
  }

  getComponentValue(index: number): string {
    if (this.activeUser) {
      if (this.activeUser.vector.current && this.activeUser.vector.current.components && this.activeUser.vector.current.components[index]) {
        return this.activeUser.vector.current.components[index];
      } else if (this.activeUser.vector.previous && this.activeUser.vector.previous.components && this.activeUser.vector.previous.components[index]) {
        return this.activeUser.vector.previous.components[index];
      }
    }
    return '';
  }

  changeOne(value) {
    if(value > 100) {
      this.valueOne = 100
    }  
    if(value < 0) {
      this.valueOne = 0
    } 
  }

  changeTwo(value) {
    if(value > 90) {
      this.valueTwo = 90
    }  
    if(value < -90) {
      this.valueTwo = -90
    } 
  }

  changeThree(value) {
    if(value > 100) {
      this.valueThree = 100
    }  
    if(value < 0) {
      this.valueThree = 0
    } 
  }

  changeFour(value) {
    if(value > 100) {
      this.valueFour = 100
    }  
    if(value < 0) {
      this.valueFour = 0
    } 
  }

  changeFive(value) {
    if(value > 100) {
      this.valueFive = 100
    }  
    if(value < 0) {
      this.valueFive = 0
    } 
  }

  action(id) {
    this.activeUser = id;
  }

  disabledBtnOne() {
    return this.valueOne !== null;
  }

  disabledBtnTwo() {
    return this.valueTwo !== null;
  }

  disabledBtnThree() {
    return this.valueThree !== null;
  }

  disabledBtnFour() {
    return this.valueFour !== null;
  }

  disabledBtnFive() {
    return this.valueFive !== null;
  }

 
  setChangeLog() {
    this.adminService.changeVector(this.activeUser.user.id, this.valueOne, this.valueTwo, this.valueThree, this.valueFour, this.valueFive).subscribe(
      (response) => {
        this.activeModal.close('ok');
      })
  }
} 



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-group/vector-value/vector-value.component.ts